var ModuleVersion = {};

const ksaType = "_ksa"
const kwType = "_kw_onboard"
// const latumType = "latum"


ModuleVersion.ksa = {
    Random: ksaType,
    NumberSearch: ksaType,
    Eligibility: ksaType,
    CreateAccount: ksaType,
    Category: ksaType,
    PlanSelection: ksaType,
    Footer: ksaType,
    SimSelection: ksaType,
    Header: ksaType,
    TopUp: ksaType,
    isAppVariable: ksaType,
    Mnp: ksaType,
    Summary: ksaType,
    Payment: ksaType,
    DropOff: ksaType,
    StorePickUp: ksaType,
    ActivateSimTab: ksaType
}


ModuleVersion.kw = {
    Random: kwType,
    NumberSearch: kwType,
    Eligibility: kwType,
    CreateAccount: kwType,
    Category: kwType,
    PlanSelection: kwType,
    Footer: kwType,
    SimSelection: kwType,
    Header: kwType,
    TopUp: kwType,
    isAppVariable: kwType,
    Mnp: kwType,
    Summary: kwType,
    Payment: kwType,
    DropOff: kwType,
    StorePickUp: kwType,
    ActivateSimTab: kwType
}

// if new latum type of component is added
// ModuleVersion.latum = {
//     Random: ksaType,
//     NumberSearch: ksaType,
//     Eligibility: latumType,
//     CreateAccount: latumType,
//     Category: kwType
// }


export default ModuleVersion;
